import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import Loader from '../../components/loader';
import './style.scss';

const LoaderContext = createContext();

function LoaderProvider({ children }) {
  const [active, setActive] = useState(false);

  const show = useCallback(async nextActive => {
    setActive(nextActive);
    const root = document.querySelector(':root');
    root.style.setProperty('overflow', nextActive ? 'hidden' : 'unset', 'important');
    root.style.setProperty(
      '--backdrop-top',
      `${document.documentElement.scrollTop}px`
    );
  }, []);

  const setDefault = useCallback(() => {
    setActive(false);
  }, []);

  const contextValue = useMemo(
    () => ({ active, show, setDefault }),
    [active, show, setDefault]
  );

  return (
    <LoaderContext.Provider value={contextValue}>
      {active ? (
        <div className='backdrop'>
          <Loader></Loader>
        </div>
      ) : null}
      {children}
    </LoaderContext.Provider>
  );
}

function useLoader() {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error('useLoader must be used within a LoaderProvider');
  }
  return context;
}

export { LoaderProvider, useLoader };
